export const mapThemingColor = (value, theme, defaultValue) => {
  if (value === 'default') return defaultValue
  if (value === 'primary') return theme.palette.primary.main
  if (value === 'primaryContrast') return theme.palette.primary.contrastText
  return value || defaultValue
}
